import { LocalMapType } from "@evennt-tech/api-v2-core";
import DefaultLocalMap from "./defaultLocalMap";

const makeLowerCase = (value: string | null, key: LocalMapType) => {
  if (!value) return value;

  return value !== DefaultLocalMap[key] ? value : value.toLowerCase();
};

export default makeLowerCase;
